import React, { Component } from 'react';
import SearchContainer from './SearchContainer';
import PropTypes from 'prop-types';

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.props = props;

    this.state = {
      searchInput: '',
      isShow: '',
    }
  }

  componentDidUpdate(prevISO) {
    if(this.props.countryToISO !== prevISO.countryToISO && this.props.countryToISO === '') {
      this.setState({...this.state, isShow: '', searchInput: ''})
    }
  }

  editSearchItem = (e) => {
    if (e.target.value.length) {
        this.setState({...this.state, isShow: 'show', searchInput: e.target.value})
        this.props.countryISO('', this.props.direction)
    } else {
        this.setState({...this.state, isShow: '', searchInput: e.target.value})
        this.props.countryISO('', this.props.direction)
    }
  }

  showMessage = () => {
    this.setState({...this.state, isShow: 'show'});
  }

  selectedCountry = (isocode, country, isValid) => {
    this.setState({...this.state, isShow: '', searchInput: isValid ? country : ''}, 
      () => {this.props.countryISO(isocode, this.props.direction)});
  }

  dynamicSearch = () => {
    return this.props.countries.filter(country=> 
      country.countryName.toLowerCase().includes(this.state.searchInput.toLowerCase()))
  }

  closeSearchContainer = () => {
    if (this.state.searchInput.length === 0) {
      this.setState({...this.state, isShow: ''})
    }
  }

  render(){
      return (
        <div className="search-bar">
          <input type= 'text' value = {this.state.searchInput}
                 onChange = {this.editSearchItem} placeholder = {this.props.placeholder} 
                 onFocus = {this.showMessage}
                 onBlur = {this.closeSearchContainer}
                 disabled={this.props.isDisabled}/>
          <label htmlFor='seach'></label>
          <SearchContainer  country={this.dynamicSearch()} 
                            show={this.state.isShow} 
                            select={this.selectedCountry}
                            currentInput={this.state.searchInput}
                            defaultStaticContentCalc={this.props.defaultStaticContentCalc}
                            activeLangStaticContentCalc={this.props.activeLangStaticContentCalc}/>
        </div>
      );
    }
}

export default SearchBar;

SearchBar.propTypes = {
  countryISO: PropTypes.func.isRequired,
  direction: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  countries: PropTypes.array.isRequired,
  isValid: PropTypes.bool.isRequired,
  isDisabled: PropTypes.string,
  countryToISO: PropTypes.string,
  defaultStaticContentCalc: PropTypes.object,
  activeLangStaticContentCalc: PropTypes.object,
}
